module.exports = __webpack_public_path__ + "img/常虹.b4085417.jpg";